<template>
  <div>
    <app-header title="Film Type Categories">
      <button
        v-router-link="{ name: 'filmtypecategory-editor' }"
        class="btn btn-primary"
      >
        <i class="fa fa-plus-circle" /> New Category
      </button>
    </app-header>
    <loading-spinner v-if="!categories" />
    <b-container v-else>
      <b-table :items="categories" :fields="fields">
        <template v-slot:cell(name)="data">
          <span
            class="categorylist--clickable"
            @click="viewCategory(data.item)"
          >
            {{ data.item.name }}
          </span>
        </template>
      </b-table>
    </b-container>
  </div>
</template>

<script>
import $api from '@/services/api';
import AppHeader from '@/components/AppHeader';
import LoadingSpinner from '@/components/LoadingSpinner';

export default {
  components: {
    AppHeader,
    LoadingSpinner,
  },

  data: () => ({
    categories: null,
    fields: ['name'],
  }),

  created() {
    this.refreshData();
  },

  methods: {
    async refreshData() {
      this.categories = await $api.get('/v1/common/filmtypecategories');
    },

    viewCategory(item) {
      this.$router.push({
        name: 'filmtypecategory-editor',
        query: { id: item.id },
      });
    },
  },
};
</script>
<style scoped>
.categorylist--clickable:hover {
  cursor: pointer;
  text-decoration: underline;
}
</style>
